import api from 'core/api';

export const getScheduleSession = (sessionId) => api.get(`coach_schedule_sessions/${sessionId}`);
export const getCoachScheduleSessions = (userId) =>
  api.get(`coach_schedule_sessions/coach/${userId}`);
export const getUserScheduleSessions = (userId) =>
  api.get(`coach_schedule_sessions/user/${userId}`);
